import { Box, Typography } from "@mui/material";
import { colors } from "../../ui/colors";
import pkg from "../../../../package.json";

export const HelpSupportMessage = ({ emailDirection }) => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          py: 2,
          px: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.85rem",
            color: colors.gray[600],
            textAlign: "center",
          }}
        >
          For support and help, send a message to{" "}
          <Box
            component="span"
            sx={{
              color: colors.gray[800],
              fontWeight: 500,
            }}
          >
            {emailDirection}
          </Box>
        </Typography>
        <Typography sx={{ fontSize: 12, opacity: 0.7 }}>V{pkg?.version}</Typography>
      </Box>
    </>
  );
};
